import type { FaireProductEntity } from "../../entity_types/product";

export const p_ps4666bejp: FaireProductEntity = {
  token: "p_ps4666bejp",
  type: "product",
  name: "Cold and Flu Maximum Strength",
  brandToken: "b_63rejl12p8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/dffed1382ec6a2c5d17b4aa6eb62c6376563ed747d93fa9e2f7668e99256ad64.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/350489b291ba935333a3213ad5b52e501201543834fb3198d23b91dcd3682682.png",
    "https://cdn.faire.com/fastly/1f8e23963604d3fc69255524be2df7e467d8a0e1537a28699af1791b4d3a9aed.png",
    "https://cdn.faire.com/fastly/e36041f3dca0c910c2f80b95627b4ad46a499edc1c8cceada225dd1899d6277a.png",
    "https://cdn.faire.com/fastly/e6c59931eefda85196dde5ca6503f76380a1d06ec1cf17dfe0bc56b73adbb774.jpeg",
    "https://cdn.faire.com/fastly/f386a27e8984c9b3b00d81670b8f6ac356f87a6c1b417d3335fa407ac1ce2621.png",
    "https://cdn.faire.com/fastly/c825a029f1bd8491aa6eb2617ec01cc36167944a21fdbc1e3a3fb6c37ad1d17a.jpeg",
    "https://cdn.faire.com/fastly/ced0edfeac03079e117ba6f5a44f06f8501e4f6bd18d103c56d24ea717641f9e.png",
    "https://cdn.faire.com/fastly/2d14bf657324b2d16ec3c9d6f4f7f3da88f0850dcfb612ee4f71cde65cb0329e.png",
    "https://cdn.faire.com/fastly/e57ee01c2c4f263f653d05ecdd65a8b957509364c80db445c432dc758a15ee96.png",
    "https://cdn.faire.com/fastly/9900d4f89121b4593f1a439de309fee58a577a8eb03c63d20252a4883b0a82da.png",
  ],
  priceDollars: 9.67,
  description:
    "Forces of Nature Cold & Flu Maximum Strength delivers fast, all natural relief from tough cold and flu symptoms: congestion, cough, sore throat, body aches, and fatigue. Powered by a blend of certified organic homeopathic ingredients including Sambucus Nigra (Elderberry) and Berberis Vulgaris (Barberry), both packed with antioxidants and known for their ability to support the immune system, this advanced formula helps you bounce back faster. Cold & Flu Maximum Strength works in harmony with your body to fight symptoms and support immune response offering a natural approach compared to conventional products that can cause drowsiness, cotton mouth or other unwanted side effects.\n\nCertified Organic, Non-GMO Project Verified, and cruelty free, Cold & Flu Maximum Strength sets a higher standard for cold care. Non-drowsy and free from high fructose corn syrup, artificial flavors, or dyes, this clean, plant-based formula works naturally to ease your symptoms.\n\nSee also our Cold & Flu Kids for a child-friendly version of this formula designed for ages 3 - 12.",
  tags: [],
  msrpDollars: 19.33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:15.704Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
